import { FREESTAR_PUBLISHER } from './placements';

export const FREESTAR_PUBFIG_SCRIPT_ID = 'freestar-pubfig';
export const FREESTAR_PUBFIG_IDLE_TIMEOUT_MS = 2000;
export const FREESTAR_PUBFIG_SRC = `https://a.pub.network/${FREESTAR_PUBLISHER}/pubfig.min.js`;

const PUBFIG_INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart'] as const;

export const injectFreestarPubfig = (): void => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(FREESTAR_PUBFIG_SCRIPT_ID)) return;

  const pubfigScript = document.createElement('script');
  pubfigScript.async = true;
  pubfigScript.dataset.cfasync = 'false';
  pubfigScript.id = FREESTAR_PUBFIG_SCRIPT_ID;
  pubfigScript.src = FREESTAR_PUBFIG_SRC;
  document.head.appendChild(pubfigScript);
};

export const scheduleFreestarPubfig = (): (() => void) => {
  let didStart = false;
  let idleCallbackId: number | undefined;
  let fallbackTimerId: number | undefined;

  const startPubfigLoad = (): void => {
    if (didStart) return;
    didStart = true;
    removeInteractionListeners();
    cancelScheduledLoad();
    injectFreestarPubfig();
  };

  const removeInteractionListeners = (): void => {
    for (const eventName of PUBFIG_INTERACTION_EVENTS) {
      window.removeEventListener(eventName, startPubfigLoad);
    }
  };

  const cancelScheduledLoad = (): void => {
    if (idleCallbackId !== undefined && typeof window.cancelIdleCallback === 'function') {
      window.cancelIdleCallback(idleCallbackId);
      idleCallbackId = undefined;
    }
    if (fallbackTimerId !== undefined) {
      window.clearTimeout(fallbackTimerId);
      fallbackTimerId = undefined;
    }
  };

  for (const eventName of PUBFIG_INTERACTION_EVENTS) {
    window.addEventListener(eventName, startPubfigLoad, { passive: true });
  }

  if (typeof window.requestIdleCallback === 'function') {
    idleCallbackId = window.requestIdleCallback(startPubfigLoad, { timeout: FREESTAR_PUBFIG_IDLE_TIMEOUT_MS });
  } else {
    fallbackTimerId = window.setTimeout(startPubfigLoad, FREESTAR_PUBFIG_IDLE_TIMEOUT_MS);
  }

  return () => {
    removeInteractionListeners();
    cancelScheduledLoad();
  };
};
